// extracted by mini-css-extract-plugin
export default {"headerContainerOuter":"IndexHeader_headerContainerOuter__XXxdw","headerContainer":"IndexHeader_headerContainer__DxNaH","backButton":"IndexHeader_backButton__FIN6+"};